module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "work"
  }, [_c('div', {
    ref: "overlay",
    staticClass: "overlay"
  }), _vm._v(" "), _c('navigation'), _vm._v(" "), _c('div', {
    ref: "work",
    staticClass: "section-title"
  }, [_vm._v("Work")]), _vm._v(" "), _c('div', {
    ref: "cases",
    staticClass: "case-studies"
  }, _vm._l((_vm.caseStudies), function(caseStudy) {
    return _c('case-study', {
      key: caseStudy.to,
      attrs: {
        "title": caseStudy.title,
        "subtitle": caseStudy.subtitle,
        "to": caseStudy.to
      }
    })
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bf7c37c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work.vue
// module id = 181
// module chunks = 1